.shell {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  min-height: 100%;
  overflow: hidden;
  background: var(--color-bg);
}

/* Two overlapping light beams from the top, like a projector in a dark room. */
.backdrop {
  position: absolute;
  inset: 0;
  background:
    radial-gradient(ellipse 60% 50% at 20% -10%, rgba(229, 9, 20, 0.34), transparent 70%),
    radial-gradient(ellipse 50% 45% at 85% 0%, rgba(229, 9, 20, 0.16), transparent 70%),
    linear-gradient(180deg, transparent 55%, var(--color-bg) 100%);
  pointer-events: none;
}

.top {
  position: relative;
  padding: var(--space-6) var(--space-7);
}

.center {
  position: relative;
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: var(--space-6) var(--space-6) var(--space-10);
  text-align: center;
  animation: sr-rise 220ms var(--ease-out);
}

.headline {
  font-size: clamp(34px, 6vw, 56px);
  font-weight: 800;
  letter-spacing: -0.03em;
  line-height: 1.05;
  max-width: 14ch;
  margin-bottom: var(--space-3);
}

.subline {
  color: var(--color-text-muted);
  font-size: var(--fs-lg);
  max-width: 34ch;
  margin-bottom: var(--space-7);
}

.panel {
  width: 100%;
  max-width: 420px;
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
  text-align: left;
  padding: var(--space-7);
  background: rgba(0, 0, 0, 0.72);
  border-radius: var(--radius-md);
  box-shadow: var(--shadow-overlay);
}

.footer {
  margin-top: var(--space-5);
  font-size: var(--fs-sm);
  color: var(--color-text-muted);
}

.footer a {
  color: var(--color-text);
  font-weight: 700;
}

/* Form pieces shared by the gates. */
.form {
  display: flex;
  flex-direction: column;
  gap: var(--space-5);
}

.submit {
  width: 100%;
  height: 48px;
  font-size: var(--fs-md);
}

.error {
  font-size: var(--fs-xs);
  color: var(--color-error);
}

.code {
  height: 54px;
  font-size: var(--fs-xl);
  letter-spacing: 0.18em;
  text-transform: uppercase;
  font-family: var(--font-mono);
  text-align: center;
}

@media (max-width: 520px) {
  .top {
    padding: var(--space-5);
  }
  .panel {
    padding: var(--space-5);
  }
}
